import { apiRequest } from './apiClient'
import { getValidToken } from './authService'

// Кампании дилера (пропозиції): окно при входе, просмотр, кнопка.
// Только владелец аккаунта: суб-юзеру сервер отвечает 403. Отписки нет (решение 19.10.2026).

const authHeaders = () => {
  const token = getValidToken()
  return token ? { Authorization: `Bearer ${token}` } : {}
}

// Картинка кампании отдаётся портальным API без входа (по случайному токену)
const API_BASE = import.meta.env.VITE_CLIENT_API_BASE || '/client/api'
export const campaignImageUrl = (imagePath) => (imagePath ? `${API_BASE}${imagePath}` : null)
// Картинки в тексте кампании хранятся путём /campaign-image/<token>: показываем через API портала
export const resolveCampaignHtml = (html) => (html || '').replaceAll('src="/campaign-image/', `src="${API_BASE}/campaign-image/`)

export async function fetchCampaignPopup() {
  return apiRequest('/campaigns/popup', { method: 'GET', headers: authHeaders() })
}

export async function fetchCampaign(id) {
  return apiRequest(`/campaigns/${id}`, { method: 'GET', headers: authHeaders() })
}

// popup=true гасит окно при следующем входе; просмотр из колокольчика только отмечает «открыто»
export async function markCampaignSeen(id, popup = false) {
  return apiRequest(`/campaigns/${id}/seen`, {
    method: 'POST',
    headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ popup }),
  })
}

export async function markCampaignClick(id) {
  return apiRequest(`/campaigns/${id}/click`, { method: 'POST', headers: authHeaders() })
}

// Кнопка «Хочу»: заявка дилеру
export async function sendCampaignInterest(id) {
  return apiRequest(`/campaigns/${id}/interest`, { method: 'POST', headers: authHeaders() })
}
